import { motion } from 'framer-motion';

export default function SuccessConfetti() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {[...Array(50)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 rounded-full"
          style={{
            background: `hsl(${Math.random() * 60 + 30}, 100%, 50%)`,
            top: '50%',
            left: '50%',
          }}
          animate={{
            x: Math.random() * 400 - 200,
            y: Math.random() * 400 - 200,
            scale: [1, 0],
            opacity: [1, 0],
          }}
          transition={{
            duration: 1 + Math.random(),
            ease: 'easeOut',
            delay: Math.random() * 0.2,
          }}
        />
      ))}
    </div>
  );
} 